import type { MeResponse } from "../../api/user";
import { ROUTES } from "../../routes.js";

/**
 * The demo's one way out, for the banner and the restricted-action dialog
 * alike: signed-out visitors are sent to log in, teachers and admins straight
 * to creating a Lernreise. Students get nothing — the demo isn't for them.
 *
 * `banner` is the standing invitation across the top; `dialog` is the same
 * invitation after clicking something the demo hasn't got.
 */
export const demoCallToAction = (me: MeResponse | null) => {
  if (!me) {
    return {
      label: "Anmelden",
      to: ROUTES.login.getUrl(),
      banner:
        "Registriere dich kostenlos für die komplette Digital Sparks Erfahrung!",
      dialog:
        "Diese Funktionalität ist in der Demo nicht verfügbar. Melde dich doch an und lege richtig los - dauert nur 30 Sekunden und ist DSGVO-konform :).",
    };
  }
  if (!me.isAnon && me.email) {
    return {
      label: "Lernreise erstellen",
      to: ROUTES.lernreisenCreate.getUrl(),
      banner:
        "Erstelle deine eigene Lernreise für die komplette Digital Sparks Erfahrung!",
      dialog:
        "Diese Funktionalität ist in der Demo nicht verfügbar. Erstelle deine eigene Lernreise für die komplette Digital Sparks Erfahrung!",
    };
  }
  return null;
};
